import axios from 'axios';

export async function setPrimaryMfaProvider(provider) {
  await axios.put(`/api/?entity=twoFactorAuthentication&action=primary2fa`, {provider});
}
